(function ($) {
  $(document).ready(function () {
    if ($(".intro-with-slider ").length > 0) {
      setTimeout(function () {
        $(".intro-with-slider .row-wrap .slider-wrap").css({opacity: "1"});
        $(".intro-with-slider .row-wrap .slider-wrap .card .text-wrap").matchHeight();
      }, 500);
      if ($(".intro-with-slider .row-wrap .slider-wrap .card").length > 2) {
        $(".intro-with-slider .row-wrap .slider-wrap").slick({
          slidesToShow: 3,
          slidesToScroll: 1,
          dots: false,
          arrows: true,
          infinite: true,
          responsive: [
            {
              breakpoint: 1449,
              settings: {
                slidesToShow: 2,
                draggable: true,
              },
            },
            {
              breakpoint: 991,
              settings: {
                slidesToShow: 2,
                draggable: true,
              },
            },
            {
              breakpoint: 596,
              settings: {
                slidesToShow: 1,
                dots: true,
                arrows: false,
              },
            },
          ],
        });
      }
    }
  });
})(jQuery);